import { nextTick } from 'vue';
import { useEventListener, useResizeObserver } from '@vueuse/core';

export function useFocusVisibility(container) {
  function revealFocusedControl() {
    const control = document.activeElement;
    if (!(control instanceof HTMLElement) || !container.value?.contains(control)) {
      return;
    }
    if (!control.matches('input, textarea') && !control.isContentEditable) {
      return;
    }

    control.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  // Drawer restores its temporary input transform after dispatching focus.
  useEventListener(container, 'focusin', () => nextTick(revealFocusedControl));
  // Observe the rendered scroll area, including native WebView keyboard resizing.
  useResizeObserver(container, revealFocusedControl);
}
